import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        { text: 'تاریخ', value: 'date', align: 'center' },
        { text: 'از', value: 'from', align: 'center' },
        { text: 'به', value: 'to', align: 'center' },
        { text: 'کاربر', value: 'user', align: 'center' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
        { text: 'مدت انتظار', value: 'waitTime', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'قطع کننده', value: 'hangSide', align: 'center' },
        { text: 'عملیات', value: 'actions', align: 'center', sortable: false },
      ],
      tableItems: [],
      recordFile: '',
      player: false,
      searchFromDate: '',
      searchToDate: '',
      userId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      userFullName: '',
      roleId: '',
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        let hangSide = '';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        let duration1 = null;
        if (data[i].callLog) {
          duration1 = Math.round(data[i].callLog.holdTime);
          duration1 = duration1 * 1000;
        }
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].user) {
          user += data[i].user.firstName ? data[i].user.firstName : '-';
          user += ' ';
          user += data[i].user.lastName ? data[i].user.lastName : '-';
        }
        if (data[i].callLog) {
          if (data[i].callLog.hangUpSide == 0) {
            hangSide = 'تماس گیرنده';
          } else if (data[i].callLog.hangUpSide == 1) {
            hangSide = 'پاسخ دهنده';
          } else {
            hangSide = '-';
          }
        }
        this.tableItems.push({
          date: date,
          from: data[i].callLog && data[i].callLog.callerId ? data[i].callLog.callerId : '-',
          to: data[i].destination ? data[i].destination : '-',
          user: user,
          duration: this.msToTime(duration),
          callLogId: data[i].callLog ? data[i].callLog?.id : null,
          waitTime: this.msToTime(duration1),
          status:
            data[i].callTag && data[i].callTag.persianTitle ? data[i].callTag.persianTitle : '-',
          hangSide: hangSide,
        });
      }
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.userId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCCallsReportFunction(
        this.searchFromDate,
        this.searchToDate,
        null,
        null,
        null,
        this.userId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.userId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    stopMusic: function () {
      var sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
    backToReport: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'qcUser115Dashboard', params: { id: id } });
    },
  },
};
